// Import Redux Types
import {
  OPEN_MODAL,
  CLOSE_MODAL,
  SET_DATA_MODAL
} from '../types/index'



// Functions
export function openModalAction( type:string ) {
  return async ( dispatch:any ) => {
    dispatch( openModal( type ) )
  }
}
const openModal = (type:string) => ({
  type: OPEN_MODAL,
  payload: type
})

export function closeModalAction() {
  return async ( dispatch:any ) => {
    dispatch( closeModal() )
  }
}
const closeModal = () => ({
  type: CLOSE_MODAL
})

export function setDataModalAction( modalType:string, dataModal:{} ) {
  return async ( dispatch:any ) => {
    dispatch( setDataModal( modalType, dataModal ) )
  }
}
const setDataModal = ( modalType:string, dataModal:{} ) => ({
  type: SET_DATA_MODAL,
  payload: {modalType, dataModal}
})
